/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Link field representation.
 */
export interface LinkClaimValue {
    /** The link field value. */
    value: Truvity.CredentialClaimLinkedCredentialValue;
}
